import { QueryClient, useQuery } from '@tanstack/react-query';
import { AccountApi } from 'api/ApiHelper';
import { AxiosRequestConfig } from 'axios';
import { accountsQueryKey } from 'queries/account/queryKey';

export const prefetchUserMarketingAgreementQuery = async (queryClient: QueryClient, options: AxiosRequestConfig) =>
  queryClient.fetchQuery({
    queryKey: accountsQueryKey.marketingAgreement,
    queryFn: () => AccountApi.getUserMarketingAgreement(options),
  });

export const useGetUserMarketingAgreementQuery = () =>
  useQuery({ queryKey: accountsQueryKey.marketingAgreement, queryFn: () => AccountApi.getUserMarketingAgreement() });
